import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";
import { useEffect, useState } from "react";

const LINES = [
  "Scoring your operational foundation…",
  "Weighing capital & compliance…",
  "Analyzing your experience profile…",
  "Generating your personalized plan…",
];

export default function Analyzing() {
  const [line, setLine] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setLine((l) => (l + 1) % LINES.length), 1400);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center text-center px-8">
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 1.2, ease: "linear" }}
      >
        <Loader2 className="w-12 h-12 text-brand" strokeWidth={2.5} />
      </motion.div>
      <div className="text-xs tracking-[0.3em] uppercase font-bold text-slate-500 mt-10 mb-3">
        AI Analysis in progress
      </div>
      <motion.p
        key={line}
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        className="font-heading text-xl sm:text-2xl font-semibold text-white"
      >
        {LINES[line]}
      </motion.p>
    </div>
  );
}
